import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { GetSubsidyResponse } from '@hc-frontend/services';
import { Dispatch, SetStateAction } from 'react';

import { AnswersObject, ResultStatus } from './constants';

type SubmitAnswersParams = {
  answers: AnswersObject;
  setSubsidy: Dispatch<SetStateAction<GetSubsidyResponse | undefined>>;
  setStatus: Dispatch<SetStateAction<ResultStatus>>;
  minLoadingTime: number;
};

export async function submitAnswers({
  answers,
  setSubsidy,
  setStatus,
  minLoadingTime,
}: SubmitAnswersParams): Promise<void> {
  const config = getClientApplicationConfig();
  const url = `${config.core.appBaseUrl}/mp2/api/widgets/subsidy/`;
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(answers)) {
    params.append(key, String(value));
  }

  setStatus('loading');

  // At least wait for the minLoadingTime to show all the loading animations.
  const [data] = await Promise.allSettled([
    fetch(`${url}?${params.toString()}`).then((response) => response.json()),
    new Promise((r) => setTimeout(r, minLoadingTime)),
  ]);

  if (data.status !== 'fulfilled') {
    setStatus('error');
    return;
  }

  if (data.value.result !== 'success') {
    setStatus('error');
    return;
  }

  setSubsidy(data.value.body);
  setStatus('success');
}
